import getSubscriptionLabel from './getCheckboxLabel';
const getFirstSubscription = (subscriptions, consentCheckboxes) => {
  const {
    id
  } = subscriptions[0];
  return {
    communicationTypeId: id,
    label: getSubscriptionLabel(consentCheckboxes, id)
  };
};
export default getFirstSubscription;